import { GenericApiResponse, Header, Pagination } from '../general-store/general.model';
import { Product } from '../products-store/products.model';
import { Organization } from '../organizations-store/organizations.model';

export interface AntiCounterfeitStateModel {
  isProcessing: boolean;
  isListRefreshing: boolean;
  antiCounterfeitOrders: AntiCounterfeitOrder[];
  antiCounterfeitOrder: AntiCounterfeitOrder | null;
  pagination: Pagination;
  headers: Header[];
}

export interface AntiCounterfeitOrder {
  id: number;
  qrOrderId: number;
  productId: number;
  organizationId: number;
  createdById: number;
  quantity: number;
  printerVendor: string;
  status: AntiCounterfeitOrderStatus;
  orderedDate: string;
  receivedDate?: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  product: Product;
  organization: Organization;
  qrOrder: any; // Reference to the original QR order
}

export enum AntiCounterfeitOrderStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETE = 'COMPLETE',
  CANCELLED = 'CANCELLED',
}

export interface CreateAntiCounterfeitOrderParams {
  qrOrderId: number;
  printerVendor: string;
  quantity: number;
}

export interface AntiCounterfeitOrdersResponse extends GenericApiResponse {
  payload: AntiCounterfeitOrder[];
}

export interface AntiCounterfeitOrderResponse extends GenericApiResponse {
  payload: AntiCounterfeitOrder;
}
